<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">
      {{ 'sample.list.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      data-cy="sample-dialog-close-icon"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <app-samples-list
      [serviceDataId]="serviceDataId"
      [readonly]="false"
    ></app-samples-list>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      class="btn btn-clear"
      (click)="modalRef.close()"
      data-cy="sd-details-close-btn"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
